import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import { withRouter } from "react-router";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap";
import "../include/jQuery";
import "../thema/App.css";
import "react-toastify/dist/ReactToastify.css";
// import "../thema/react-select-search.css";

import Home from "../routers/Home";
import Category from "../routers/Category";
import CategoryNavigation from "../routers/CategoryNavigation";
import CategoryShowcasePage from "../routers/CategoryShowcase";
import DealProducts from "../routers/DealProducts";
import Product from "../routers/Product";
import SearchResults from "../routers/Search";
import SliderProducts from "../routers/SliderProducts";
import CartDetail from "../routers/CartDetail";
import CheckoutLogin from "../routers/Checkout/login";
import UnifiedCheckout from "../routers/Checkout/unified";
import CheckoutSuccess from "../routers/Checkout/success";
import PaymentFailed from "../routers/Checkout/odeme-basarisiz";
import PaymentWaiting from "../routers/Checkout/waiting";

import Forgot from "../routers/Forgot";
import ResetPassword from "../routers/Forgot/reset";

import Login from "../routers/Login";
import Register from "../routers/Register";
import Account from "../routers/Account";
import AccountOrders from "../routers/Account/orders";
import AccountOrdersHistory from "../routers/Account/orders_history";
import Address from "../routers/Account/address";

import OrderDetail from "../routers/Account/order_detail";
import Profile from "../routers/Account/profile";
import EditPassword from "../routers/Account/edit_password";

import Page from "../routers/Page";
import Blog from "../routers/Blog";
import BlogDetail from "../routers/BlogDetail";
import OrderEnquiry from "../routers/OrderEnquiry ";

import HeaderTop from "./shared/HeaderTop";
import Header from "./shared/Header";
import ModernHeader from "./shared/ModernHeader";
import Footer from "./shared/Footer";
import PerformanceMonitor from "./shared/PerformanceMonitor";
import NotFound404 from "./shared/404";
import CookieConsent from "./CookieConsent";

import { me } from "../store/actions/customer";
import { loadCart } from "../store/actions/cart";
import { getSettingData } from "../store/actions/setting";
import { getAllPagesData } from "../store/actions/page";
import Carousel from "./Carousel";
import { ToastContainer } from "react-toastify";

// Development modunda GA4 test araçlarını yükle
if (process.env.NODE_ENV === "development") {
  import("../utils/ga4-test");
}

library.add(fas, fab);

class App extends Component {
  state = {
    hasError: false,
    loading: false,
  };

  async loadPage() {
    await this.props.loadCart();
    !this.props.customer.customer && (await this.props.me());
    !this.props.setting.setting && (await this.props.getSettingData());
    this.setState({ loading: true });
  }

  componentDidMount() {
    !this.props.page.page && this.props.getAllPagesData();
    this.loadPage();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    window.jQuery("html, body").animate({ scrollTop: 0 }, 300);
  }

  // componentDidCatch(error, info) {
  //   // Display fallback UI
  //   this.setState({ hasError: true });
  //   // You can also log the error to an error reporting service
  //   // logErrorToMyService(error, info);
  // }

  render() {
    if (this.state.hasError) {
      return "Hata Oldu!";
    }
    if (!this.state.loading)
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
            position: "absolute",
            backgroundColor: "#f0f0f0",
          }}
        >
          <FontAwesomeIcon icon="spinner" spin size={"lg"} />
        </div>
      );

    // Minimal layout için ödeme sayfalarını kontrol et
    const checkoutPaths = ["/odeme", "/odeme/misafir"];
    const isCheckoutPage = checkoutPaths.some(
      function (path) {
        return this.props.location.pathname === path;
      }.bind(this)
    );

    return (
      <div className="app-container">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {/* Ödeme sayfalarında header gizle */}
        {!isCheckoutPage && <ModernHeader />}

        <main className="main-content">
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/deals" component={DealProducts} />
            <Route exact path="/p/:slug" component={Page} />
            <Route exact path="/blog" component={Blog} />
            <Route exact path="/blog/:slug" component={BlogDetail} />
            <Route
              exact
              path="/siparis-sorgula/:id?"
              component={OrderEnquiry}
            />

            <Route exact path="/sifremi-unuttum" component={Forgot} />
            <Route
              exact
              path="/reset-password/:tokenID/:token"
              component={ResetPassword}
            />
            <Route exact path="/giris-yap" component={Login} />
            <Route exact path="/uye-ol" component={Register} />
            <Route exact path="/hesabim" component={Account} />
            <Route
              exact
              path="/hesabim/siparislerim"
              component={AccountOrders}
            />
            <Route
              exact
              path="/hesabim/siparis-gecmisim"
              component={AccountOrdersHistory}
            />
            <Route
              exact
              path="/hesabim/siparis/detay"
              component={OrderDetail}
            />
            <Route
              exact
              path="/hesabim/profilimi-duzenle"
              component={Profile}
            />
            <Route exact path="/hesabim/adreslerim" component={Address} />

            <Route
              exact
              path="/hesabim/sifremi-guncelle"
              component={EditPassword}
            />

            <Route exact path="/kategori/:slug" component={Category} />
            <Route
              exact
              path="/kategori-koleksiyonu/:id"
              component={CategoryNavigation}
            />
            <Route exact path="/vitrin/:id" component={CategoryShowcasePage} />
            <Route exact path="/arama" component={SearchResults} />
            <Route exact path="/slider/:id" component={SliderProducts} />
            <Route exact path="/urun/:slug" component={Product} />
            <Route exact path="/sepet" component={CartDetail} />

            <Route exact path="/odeme/giris" component={CheckoutLogin} />
            <Route exact path="/odeme" component={UnifiedCheckout} />
            <Route exact path="/odeme/misafir" component={UnifiedCheckout} />
            <Route exact path="/odeme-bekle" component={PaymentWaiting} />
            <Route exact path="/siparis-basarili" component={CheckoutSuccess} />
            <Route exact path="/odeme-basarisiz" component={PaymentFailed} />
            <Route component={NotFound404} />
          </Switch>
        </main>

        {/* Ödeme sayfalarında footer gizle */}
        {!isCheckoutPage && <Footer />}
        <CookieConsent />
        <PerformanceMonitor />
      </div>
    );
  }
}

const mapStateToProps = ({ customer, setting, page }) => {
  return { customer, setting, page };
};
const mapDispatchToProps = { me, loadCart, getSettingData, getAllPagesData };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/components/App.js